import { WorkspaceUserRole, TeamMemberRole as LegacyTeamMemberRole } from "common/interfaces";

export function getLegacyRoleFromWorkspaceUserRole(role: WorkspaceUserRole) {
    if (role === WorkspaceUserRole.OWNER) {
        return LegacyTeamMemberRole.OWNER;
    }
    if (role === WorkspaceUserRole.MEMBER) {
        return LegacyTeamMemberRole.MEMBER_LICENSED;
    }
    if (role === WorkspaceUserRole.LIBRARIAN) {
        return LegacyTeamMemberRole.LIBRARIAN;
    }
    return LegacyTeamMemberRole.MEMBER;
}

export function getWorkspaceUserRoleFromLegacyRole(role: LegacyTeamMemberRole) {
    if (role === LegacyTeamMemberRole.OWNER) {
        return WorkspaceUserRole.OWNER;
    }
    if (role === LegacyTeamMemberRole.MEMBER_LICENSED) {
        return WorkspaceUserRole.MEMBER;
    }
    if (role === LegacyTeamMemberRole.LIBRARIAN) {
        return WorkspaceUserRole.LIBRARIAN;
    }
    return WorkspaceUserRole.GUEST;
}
